import { Dashboard, Home, User } from "components/svgs";
import Enterprise from "components/svgs/Enterprise";
import GroupUser from "components/svgs/GroupUser";
import User2 from "components/svgs/User2";
import { ShipmentTypeListProps } from "interface/shipment";
import i18next from "../translations";

export const PRIMARY_FONT_FAMILY = "Nunito Sans";

export const userRoles = {
  ADMINISTRATOR: 1,
  EDITOR: 2,
  CONTRIBUTOR: 3,
  AUTHOR: 4,
};

export const STATUS_EXCEPTIONS_DESCRIPTION = (t: any) => ({
  PICK_UP_UNSCHEDULED: t(
    "Shipment has not been booked after 10 days where average booked time is 7 days.",
  ),
  PICKED_UP_LATE: t(
    "Shipment has not been picked up after 10 days where average picked-up time is 7 days.",
  ),
  POTENTIALLY_LATE_AVERAGE_TIME: t(
    "Shipment has not been delivered after 10 days where average in-transit is 7 days.",
  ),
  POTENTIALLY_LATE_EST_TIME: t("Shipment has not been delivered after estimated delivery date."),
  LATE_SHIPMENT: t("Shipment has not been delivered after committed date."),
});

// Only use for Graph View, I will change the name after understanding its meaning from the API
export const colors = {
  blue: {
    50: "#EFF3FF",
    100: "#D8E1FE",
    200: "#BFCEFE",
    300: "#9DB3FD",
    400: "#7897FF",
    500: "#6085FF",
    600: "#4F71E3",
    700: "#3958BF",
  },
  red: {
    50: "#FEF2F2",
    100: "#FEE2E2",
    200: "#FECACA",
    300: "#FCA5A5",
    400: "#F87171",
    500: "#EF4444",
    600: "#DC2626",
    700: "#B91C1C",
  },
  orange: {
    50: "#FFF7ED",
    100: "#FFEDD5",
    200: "#FED7AA",
    300: "#FDBA74",
    400: "#FF9425",
    500: "#F97316",
    600: "#EA580C",
    700: "#C2410C",
  },
  white: "#fff",
  yellow: {
    50: "#FEFCE8",
    100: "#FEF8CE",
    200: "#FEF08A",
    300: "#FDE047",
    400: "#FEC400",
    500: "#FDB614",
    600: "#CA8A04",
    700: "#A16207",
  },
  gray: {
    50: "#FAFAFD",
    100: "#F2F3F4",
    200: "#E5E7EB",
    300: "#D1D5DB",
    400: "#9CA3AF",
    500: "#6B7280",
    600: "#4B5563",
    700: "#1F2937",
    800: "#1F2937",
  },
  green: {
    50: "#ECFDF5",
    100: "#D1FAE5",
    200: "#A7F3D0",
    300: "#6EE7B7",
    400: "#30CD9A",
    500: "#10B981",
    600: "#059669",
    700: "#047857",
  },
  purple: {
    50: "#FAF5FF",
    100: "#F3E8FF",
    200: "#E9D5FF",
    300: "#D8B4FE",
    400: "#C084FC",
    500: "#B558F6",
    600: "#9333EA",
    700: "#7E22CE",
  },
};

export const pageContainerId = "Shipments-container";

export const HTTP_STATUS_CODES = {
  SUCCESS: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  GATEWAY_TIMEOUT: 504,
};

export const EmailConfig = {
  sender: "no-reply@verificationemail.com",
};

export const menu = [
  { id: 101, title: "Build", link: "/x2e-dashboard/build", icon: "" },
  {
    id: 102,
    title: "Landing Page",
    link: "/x2e-dashboard/landing-page",
    icon: "",
  },
  {
    id: 103,
    title: "Last mile promise",
    link: "/x2e-dashboard/last-mile-promise",
    icon: "",
  },
  {
    id: 104,
    title: "Warehouse and carrier performance",
    link: "/x2e-dashboard/warehouse",
    icon: "",
  },
];

export const leftMenu = [
  {
    id: 1,
    title: i18next.t("Dashboard"),
    link: "/dashboard",
    icon: <Home />,
    external: false,
    role: [],
  },
  {
    id: 2,
    title: i18next.t("Users"),
    link: "/users",
    icon: <GroupUser />,
    external: false,
    role: [],
  },
  {
    id: 3,
    title: i18next.t("Profile"),
    link: "/profile",
    icon: <User />,
    external: false,
    role: [],
  },

  {
    id: 4,
    title: i18next.t("Enterprise"),
    link: "/enterprise",
    icon: <Enterprise />,
    external: false,
    role: [],
  },
  {
    id: 5,
    title: i18next.t("User"),
    link: "/user",
    icon: <Dashboard />,
    external: false,
    role: [],
  },
];

export const profileMenu = [
  {
    id: 1,
    title: i18next.t("Profile"),
    link: "/profile",
    icon: <User2 />,
    external: false,
  },
];

export const DOUGHNUT_OPTIONS = {
  plugins: {
    tooltip: {
      callbacks: {
        title: function (tooltipItem: any) {
          return `${tooltipItem?.[0]?.formattedValue}%`;
        },
        label: function (tooltipItem: any) {
          return `${tooltipItem?.label}`;
        },
        afterLabel: function () {
          return ``;
        },
      },
      backgroundColor: "#fff",
      padding: 15,
      cornerRadius: 8,
      borderWidth: 1,
      borderColor: "#eee",
      titleColor: "#000",
      titleFont: { size: 16 },
      bodyColor: "#5D6A7A",
      bodyFont: { size: 12 },
      displayColors: false,
    },
    legend: { display: false },
  },
  aspectRatio: 1,
  layout: {
    padding: 16,
  },
  responsive: true,
};

export const API_SERVICES = {
  SHIPMENT: process?.env?.REACT_APP_ENVIRONMENT === "local" ? "/stg" : "/shipments",
};

export const FAVICON_URL =
  "https://console-images.s3.ap-southeast-1.amazonaws.com/pascal-logo-v2/favicon.ico";

export const NUMBER_DECIMAL_DIGITS = 3;

export const SHIPMENT_STATUSES = () => ({
  CREATED: {
    label: i18next.t("Created"),
    labelForMinimize: "Created",
    color: "#9CA3AF",
    backgroundColors: "#9CA3AF",
  },
  BOOKED: {
    label: i18next.t("Booked"),
    labelForMinimize: "Booked",
    color: colors.yellow[400],
    backgroundColors: colors.yellow[300],
  },
  INTRANSIT: {
    label: i18next.t("In-transit"),
    labelForMinimize: "In-transit",
    color: colors.blue[400],
    backgroundColors: colors.blue[300],
  },
  DELIVERED: {
    label: i18next.t("Delivered"),
    labelForMinimize: "Delivered",
    color: colors.yellow[600],
    backgroundColors: colors.green[300],
  },
  DELIVERED_ON_TIME: {
    label: i18next.t("Delivered On-time"),
    labelForMinimize: "On-time",
    color: colors.yellow[600],
    backgroundColors: colors.yellow[600],
  },
  DELIVERED_LATE: {
    label: i18next.t("Delivered Late"),
    labelForMinimize: "Late",
    color: colors.red[400],
    backgroundColors: colors.red[400],
  },
  RECEIVED: {
    label: i18next.t("Received"),
    labelForMinimize: "Received",
    color: colors.yellow[600],
    backgroundColors: colors.green[300],
  },
  RECEIVED_LATE: {
    label: i18next.t("Received Late"),
    labelForMinimize: "Late",
    color: colors.red[400],
    backgroundColors: colors.red[400],
  },
});

export const BAR_CHART_LABEL = {
  created: i18next.t("Created"),
  booked: i18next.t("Booked"),
  intransit: i18next.t("In-transit"),
  delivered_on_time: i18next.t("Delivered/On-time"),
  delivered_late: i18next.t("Delivered late"),
};

export const DEFAULT_PAGE_INDEX = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 200, 500];
export const YEAR_FORMAT = "YYYY";
export const DATE_TIME_FORMAT = "MM.DD.YYYY hh:mm A";
export const DATE_FORMAT = "MM.DD.YYYY";
export const DATE_FORMAT_WITHOUT_YEAR = "MMM.DD";
export const TIME_FORMAT = "hh:mm A";
export const SOURCE_DATE_FORMAT = "YYYY-MM-DD HH:mm";

export const DATE_FORMAT_FNS = "MM.dd.yyyy";
export const DATE_FORMAT_TO_DISPLAY = "MMM.DD.YYYY";
export const DATE_TIME_FORMAT_TO_DISPLAY = "MMM.DD.YYYY hh:mm A";
export const SOURCE_DATE_FORMAT_TO_DISPLAY = "MMM.DD.YYYY HH:mm";

export const ASSET_URL = "https://console-images.s3.ap-southeast-1.amazonaws.com";

// Only use for Graph View, I will change the name after understanding its meaning from the API
export const icons = {
  seaport: {
    normal: `${ASSET_URL}/shipments/seaport-blue.svg`,
    normalSelected: `${ASSET_URL}/shipments/seaport-blue-selected.svg`,
    hasIssue: `${ASSET_URL}/shipments/seaport-red.svg`,
    hasIssueSelected: `${ASSET_URL}/shipments/seaport-red-selected.svg`,
  },
  billMaterial: {
    material: `${ASSET_URL}/shipments/materials.svg`,
    materialException: `${ASSET_URL}/shipments/materials-red.svg`,
    product: `${ASSET_URL}/shipments/product.svg`,
    productException: `${ASSET_URL}/shipments/product-red.svg`,
  },
};

export const GRAPH_NODE_SIZES = {
  lg: 56,
  md: 48,
  base: 40,
  sm: 32,
  xs: 24,
};

export const GRAPH_NODE_ICON_SIZES = {
  lg: 28,
  md: 24,
  base: 20,
  sm: 16,
  xs: 12,
};

// export const MAP_ICONS = {
//   blueMarker: new L.Icon({
//     iconUrl: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/blue-marker.svg",
//     iconSize: new L.Point(24, 24),
//   }),
//   redMarker: new L.Icon({
//     iconUrl: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/red-marker.svg",
//     iconSize: new L.Point(24, 24),
//   }),
//   iconBlueMarker: new L.Icon({
//     iconUrl:
//       "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/icon-blue-marker.svg",
//     iconSize: new L.Point(32, 32),
//   }),
//   iconRedMarker: new L.Icon({
//     iconUrl: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/icon-red-marker.svg",
//     iconSize: new L.Point(32, 32),
//   }),
// };

// export const TRANSPORT_ICON_BLUE = {
//   airplane: new L.Icon({
//     iconUrl:
//       "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/airplane-blue-soild.svg",
//     iconSize: new L.Point(32, 32),
//   }),
//   ship: new L.Icon({
//     iconUrl: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/ship-blue-soild.svg",
//     iconSize: new L.Point(32, 32),
//   }),
//   train: new L.Icon({
//     iconUrl:
//       "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/train-blue-soild.svg",
//     iconSize: new L.Point(32, 32),
//   }),
//   truck: new L.Icon({
//     iconUrl:
//       "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/truck-blue-soild.svg",
//     iconSize: new L.Point(32, 32),
//   }),
// };

// export const TRANSPORT_ICON_RED = {
//   airplane: new L.Icon({
//     iconUrl: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/red-flight.svg",
//     iconSize: new L.Point(32, 32),
//   }),
//   ship: new L.Icon({
//     iconUrl: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/ship-red-soild.svg",
//     iconSize: new L.Point(32, 32),
//   }),
//   train: new L.Icon({
//     iconUrl: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/train-red-soild.svg",
//     iconSize: new L.Point(32, 32),
//   }),
//   truck: new L.Icon({
//     iconUrl: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/truck-red-soild.svg",
//     iconSize: new L.Point(32, 32),
//   }),
// };

export enum MATERIAL_TYPE {
  PRODUCT = "PRODUCT",
  MATERIAL = "MATERIAL",
}

export enum PORT_STATUS {
  CREATED = "CREATED",
  BOOKED = "BOOKED",
  INTRANSIT = "INTRANSIT",
}

export enum SHIPMENT_STATUS {
  CREATED = "CREATED",
  BOOKED = "BOOKED",
  INTRANSIT = "INTRANSIT",
  DELIVERED = "DELIVERED",
  DELIVERED_ON_TIME = "DELIVERED_ON_TIME",
  DELIVERED_LATE = "DELIVERED_LATE",
  ESTIMATE = "ESTIMATE",
  RECEIVED = "RECEIVED",
  RECEIVED_ON_TIME = "RECEIVED_ON_TIME",
  RECEIVED_LATE = "RECEIVED_LATE",
  PARTIALLY_RECEIVED = "PARTIALLY RECEIVED",
}

export const SHIPMENT_STATUS_EVENTS = {
  BOOKED: "BOOKED",
  EST_SHIPPED: "EST_SHIPPED",
  INTRANSIT: "INTRANSIT",
  ESTDELIVERED: "ESTDELIVERED",
  COMMITTED: "COMMITTED",
  DELIVERED: "DELIVERED",
  RECEIVED: "RECEIVED",
  PASCAL_ESTDELIVERED: "ESTDELIVERED_DATA_ROBOT",
  AT_PORT: "AT_PORT",
};

export const SHIPMENT_STATUS_EVENTS_ORDER = {
  BOOKED: 1,
  INTRANSIT: 2,
  DELIVERED: 3,
  "PARTIALLY RECEIVED": 4,
  RECEIVED: 5,
};

export const imagePlaceholderBase64 =
  "data:image/png;base64,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";

export const defaultThumbnailBase64 =
  "data:image/svg+xml;base64,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";

export const DEFAULT_FAVICON_IMAGE_BASE64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAABgCAYAAAB/lX6wAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAeiSURBVHgB7Z3PVxNHHMC/O7sbkgiiBFDIGqsWtFWrbX2vT4/lqsfao722t8q1/4L2Vq/ttddyxaP2vfb16cNSRVEJGww/QvmZX5ud6cxgaICEbJLd2SXM5z0lYUejn3z5znd+ZEcBl/kzlYqeDIUMTdGMYt5KAFJOIaREAEgMAouSAUIy9EFW07UXJVIyjb6+KfAIBVyAi9bCVwDjG0gFA2OIwgEHKZDFmDy1bHhyxuh/Ai7SknQum4RGUAi+bAfRtaE/BSXlMXSFHhnd3RlokaakHx7Ze8hCCR6mleL4tXg8C03SsHQzvTSCELl5yGTvgka+ov5mnIg9hiZwLJ1Fd1wL3bEJXAUJRyVkPIWtsUaj3pF0c20tBtn8KG0e4ArEL8gSRDruN5Lr60o3FxeHEYFvD3c6qUdj4veV/jY1f0NT0R2QOGETSoUfDcOYrdcQ1bqQyWaNkI6+AolTjoDW8b25ulo3BVeVznJ4bm3jO5lSGuYI5Ap364nfI51VKbLTbAWlFzaL3+zXYo/0kyh8UwpvEQTDprk0UvtyBebCwlVQ8AhIWkcjt03TPFXt0s5Ix3AbJO6BOqr63JZuzmeuy7TiMizN0HHO3m+XIfYtkLiPBXu8cukyyj2kSrRr/Hce5a6sZ7iCVbJhfXUD1tc3YG1jE/L5Aq1i8/xaPlfY0VbVVNB1DaLhMHR1ddLReIh/7Yl1Q2DYivZ75acKfxdsGAWfYaLnzDQsLC3DKpVt0+etwN6M3p5u6O/thcF4P/gMSdvFu+XZSE3FynUbCPgFk52cScGbZKpl0ZWwv2t+YZn/evkmCUNnEn7KV04SlaZwGGdPNJvg836lluXMKkz8M7UnZbhNPpeHickpLv/C8Fk40d8DwkEqW4fg0pFfHeir10n4468Jz4VXwuQ/eToJ09NJEA6CIT7FAvvMMnoJE+7Lf7zi9Z/97dkOi1oobGsKeyBc+iLNsX4KL5OaW4Dnz9+AUAo2nxYQKj1LU8nk1DQEhZnZFCRpBy4KDEi89OnpGaE53AmvaOdquVg17YemK7wH10AQLMrn3i1As7C6u+dYNx8I6boOGn2eox1jlg6c8nTg1OybaRW3StZz5xLgNZhsbS0UJn1leQUahYn+4HQcjIF+CEfC+7ZdX9uAt8k5WF5ZbfgNmDFTkKCvo9PXE4Ew6bMNRvnpRByGaPSpDkV0He2Ey5eGufCXNI018lPFon1uLs1f01vYRlpBOd2ybFj5d9Vx+w/PJuDC+TOOhVcSjnTA5YvDcLbBdLFAqyoBiKvT1zc2HLcdpKmk5fxKB9hs2J9IDDr+I+ubmyAKMdLXnUsfcqtDo+I/okN+FvlOsIolPmIVgRDp2VzRUTs2J1Kvw2yU06ecR3s2K6acFSI9l885anf8uMtz4DTa4wMnIGgI60idEA5HwG14XS+oFHSKGOm2M+m66o0cVRdWGTtCiHTbskDyP75M7R52pHQfkNJ9QEr3ASndB6R0H5DSfeBQSLetEgSJtpfOlvNErYE6pb2lE7Y4sQRBo62lsyifmZ1z3F7X22yNVDQN75NUttZZRdBW0sv72t8mU7C41NiaJ9veIYoDIZ1FberdPP9wQDXY1LFFZzJb2cgUj4tb7Ai8dCac7e71mp5jR0EUge9IJ195v8mTbflwe212PwItnS3zba4530nQDOFIhO8iE0mgpecLzha0m4VtZvri84tNbWpqhbYtGevB0slnn1wQmlbKBFq6rnrzzzt2vBuuXBzyRTgj0NKZlCN0wOJWXmey2Q6ynuP+fsY08OnlbGIAJp69hGZh+doYPAn9/T2+yy4TeOmD73dovU6+q7uVQ9V1iIZCEI1GoLMzyj+861cK2Y8D0ZEy8YMB3B7XLHLlyAekdB+Q0n1ASvcBKV0s/NYjUrpQCJ9MktIFQmVL6cJRFJleRFOyCF+4ldIFggDPbn2ViKNDldIFQ9LFoskeIH6alcRzkAJT5VsEIiDY1dOqqtHVdcRRu2jU2UfKDyIY0PbxPAg0xXPpHw+fq/sZfdHbIARDwNK279TGb8hophd+oA9PgYeU78OyupndXn5jqzrsFq1BWELzEppaXgye6Ltffs4XMTQNPSqVyNfgIfw+LJeG4TBSmVoYvHqxC4Xf0fvJGInLYLK0+7g1Lj1Oe1Wsbt2SVOIyqjq2+1vbdbrR1zdG3xVZProKma12qODOwZGu/AwStyBQ6nhQ7cIO6fyIX0RkmnEBlcCYYVQ/y27PNIBiWTLNtAotEQcG+sZqXd4jnXWqgMP3ZDXTJLRaASv0y35Nat6tPpPJGAULj2KQ59c5hgnHHfdrpZUyNWcZY7GYiRX0K0gcQUVuRjo6H9QTzqh7LoOMeAfQCGfCY7Go6aS5s+OOzbUYoPwonUSQZyHtApdsE0HkJycRXsbxCSRMvKoXb9qE3ADJFoSMp1PW2LVrHhzsXQk//cu2bx3qqGclNR1I8nFNEzR11s5hjXpWRrM5qvRM8WGj0V1JSwccbcu38fl2jny3ZJdx7VQplnYQ4CuYwKfQBnDRbClTQ4+bTSO18OQoL3YenqZoBrZLw6zURIoSw5j0QgDhI2+kZDHGOdoxzmp6aLZESqbboiv5D5gb+JxioEcDAAAAAElFTkSuQmCC";
export const DEFAULT_FAVICON_IMAGE_URL =
  "https://console-images.s3.ap-southeast-1.amazonaws.com/brand-icons/PS-New-Fav.png";

export const TRANSPORT_ICON_FILTER = {
  SEA: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/ship-blue.svg",
  SEA_RED: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/ship-red.svg",
  AIR: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/airplane-blue.svg",
  AIR_RED: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/airplane-red.svg",
  ROAD: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/truck-blue.svg",
  ROAD_RED: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/truck-red.svg",
  RAIL: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/train-blue.svg",
  RAIL_RED: "https://console-images.s3.ap-southeast-1.amazonaws.com/shipments/train-red.svg",
};

export const TRANSPORT_TYPE = ["AIR", "SEA", "ROAD", "RAIL"];

export const HOME_PAGE = "https://pascalsoftware.com";

export const SHIPMENT_TYPE_LIST: ShipmentTypeListProps[] = [
  {
    id: "1",
    name: `exceptions`,
    displayName: i18next.t(`Exception(s)`),
  },
  {
    id: "2",
    name: `followed`,
    displayName: i18next.t(`Followed`),
  },
  {
    id: "3",
    name: `all`,
    displayName: i18next.t(`All`),
  },
];

export const SHIPMENT_UNASSIGN_TYPE_LIST: ShipmentTypeListProps[] = [
  {
    id: "1",
    name: `all`,
    displayName: i18next.t(`All`),
  },
  {
    id: "2",
    name: `followed`,
    displayName: i18next.t(`Followed`),
  },
];

export const SHIPMENT_SORT_BY_OPTIONS = [
  {
    label: i18next.t("Booked date"),
    value: "bookedTime",
  },
  {
    label: i18next.t("Committed date"),
    value: "customerDeliveryDateTime",
  },
  {
    label: i18next.t("Delivered date"),
    value: "deliveryDateTime",
  },
];

export const UNASSIGNED_SHIPMENT_SORT_BY_OPTIONS = [
  {
    label: i18next.t("Booked date"),
    value: "bookedTime",
  },
  {
    label: i18next.t("Committed date"),
    value: "customerDeliveryDateTime",
  },
];

export const SORT_TYPES = {
  ASC: 1,
  DESC: -1,
};

export const PRODUCT_SORT_OPTIONS = [
  {
    label: i18next.t("Name"),
    value: "name",
  },
];

export const SORT_TYPE_REGION = [
  {
    label: i18next.t("Name"),
    value: "name",
  },
];

export const SORT_TYPE_COUNTRY = [
  {
    label: i18next.t("Name"),
    value: "name",
  },
];

export const SORT_TYPE_PRODUCT = [
  {
    label: i18next.t("Name"),
    value: "name",
  },
];
export const AT_WAREHOUSE_COUNTRIES_SORT_OPTIONS = [
  {
    label: i18next.t("Name"),
    value: "countryName",
  },
];

export const AT_WAREHOUSE_SITES_SORT_OPTIONS = [
  {
    label: i18next.t("Name"),
    value: "siteName",
  },
];

export const FILTER_SHIPMENTS_BY_STATUS = [
  {
    label: i18next.t("Statuses"),
    value: "SHIPMENT_STATUS",
    children: [
      {
        label: i18next.t("Booked"),
        value: "BOOKED",
      },
      {
        label: i18next.t("In-transit"),
        value: "INTRANSIT",
      },
      {
        label: i18next.t("Delivered"),
        value: "DELIVERED",
        children: [
          {
            label: i18next.t("Delivered On-time"),
            value: "DELIVERED_ON_TIME",
          },
          {
            label: i18next.t("Delivered Late"),
            value: "DELIVERED_LATE",
          },
          {
            label: i18next.t("Others"),
            value: "DELIVERED_OTHERS",
          },
        ],
      },
      {
        label: i18next.t("Partially Received"),
        value: "PARTIALLY RECEIVED",
      },
      {
        label: i18next.t("Received"),
        value: "RECEIVED",
        children: [
          {
            label: i18next.t("Received On-time"),
            value: "RECEIVED_ON_TIME",
          },
          {
            label: i18next.t("Received Late"),
            value: "RECEIVED_LATE",
          },
          {
            label: i18next.t("Others"),
            value: "RECEIVED_OTHERS",
          },
        ],
      },
    ],
  },
];

export const FILTER_CONTAINERS_BY_STATUS = [
  {
    label: i18next.t("Statuses"),
    value: "SHIPMENT_STATUS",
    children: [
      {
        label: i18next.t("Booked"),
        value: "BOOKED",
      },
      {
        label: i18next.t("In-transit"),
        value: "INTRANSIT",
      },
      {
        label: i18next.t("Delivered"),
        value: "DELIVERED",
        children: [
          {
            label: i18next.t("Delivered On-time"),
            value: "DELIVERED_ON_TIME",
          },
          {
            label: i18next.t("Delivered Late"),
            value: "DELIVERED_LATE",
          },
          {
            label: i18next.t("Others"),
            value: "DELIVERED_OTHERS",
          },
        ],
      },
      {
        label: i18next.t("Partially Received"),
        value: "PARTIALLY RECEIVED",
      },
      {
        label: i18next.t("Received"),
        value: "RECEIVED",
        children: [
          {
            label: i18next.t("Received On-time"),
            value: "RECEIVED_ON_TIME",
          },
          {
            label: i18next.t("Received Late"),
            value: "RECEIVED_LATE",
          },
          {
            label: i18next.t("Others"),
            value: "RECEIVED_OTHERS",
          },
        ],
      },
    ],
  },
];

export const FILTER_BY_EXCEPTIONS = [
  {
    label: i18next.t("Status Exceptions"),
    value: "SHIPMENT_EXCEPTION",
    children: [
      {
        label: i18next.t("Picked-up late"),
        value: "PICKED_UP_LATE",
      },
      {
        label: i18next.t("Potentially late"),
        value: "POTENTIALLY_LATE",
      },
      {
        label: i18next.t("Late shipment"),
        value: "LATE_SHIPMENT",
      },
    ],
  },
  {
    label: i18next.t("Data Exceptions"),
    value: "INCORRECT_FORMAT",
    children: [
      // {
      //   label: i18next.t("Missing Pick-up Event"),
      //   value: "PICK_UP_EVENT_MISSING",
      // },
      {
        label: i18next.t("Invalid Bill of Lading"),
        value: "INCORRECT_BILL_OF_LADING_FORMAT",
      },
      // {
      //   label: i18next.t("Tracking #"),
      //   value: "INCORRECT_TRACKING_FORMAT",
      // },
      {
        label: i18next.t("Invalid Container #"),
        value: "INCORRECT_CONTAINER_NUMBER_FORMAT",
      },
      {
        label: i18next.t("Invalid Origin Country Code"),
        value: "ORIGIN_INVALID_COUNTRY_CODE",
      },
      {
        label: i18next.t("Invalid Destination Country Code"),
        value: "DESTINATION_INVALID_COUNTRY_CODE",
      },
      {
        label: i18next.t("Invalid Origin Region"),
        value: "ORIGIN_INVALID_REGION",
      },
      {
        label: i18next.t("Invalid Destination Region"),
        value: "DESTINATION_INVALID_REGION",
      },
      // {
      //   label: i18next.t("Committed Date Smaller Than Booked Date"),
      //   value: "BOOKED_DATE_IS_AFTER_COMMITTED",
      // },
    ],
  },
];

export const FILTER_CONTAINER_BY_EXCEPTIONS = [
  {
    label: i18next.t("Status Exceptions"),
    value: "SHIPMENT_EXCEPTION",
    children: [
      {
        label: i18next.t("Picked-up late"),
        value: "PICKED_UP_LATE",
      },
      {
        label: i18next.t("Potentially late"),
        value: "POTENTIALLY_LATE",
      },
      {
        label: i18next.t("Late shipment"),
        value: "LATE_SHIPMENT",
      },
    ],
  },
  {
    label: i18next.t("Data Exceptions"),
    value: "INCORRECT_FORMAT",
    children: [
      {
        label: i18next.t("Invalid Bill of Lading"),
        value: "INCORRECT_BILL_OF_LADING_FORMAT",
      },
      // {
      //   label: i18next.t("Tracking #"),
      //   value: "INCORRECT_TRACKING_FORMAT",
      // },
      {
        label: i18next.t("Invalid Container #"),
        value: "INCORRECT_CONTAINER_NUMBER_FORMAT",
      },
      {
        label: i18next.t("Invalid Origin Country Code"),
        value: "ORIGIN_INVALID_COUNTRY_CODE",
      },
      {
        label: i18next.t("Invalid Destination Country Code"),
        value: "DESTINATION_INVALID_COUNTRY_CODE",
      },
      {
        label: i18next.t("Invalid Origin Region"),
        value: "ORIGIN_INVALID_REGION",
      },
      {
        label: i18next.t("Invalid Destination Region"),
        value: "DESTINATION_INVALID_REGION",
      },
      // {
      //   label: i18next.t("Committed Date Smaller Than Booked Date"),
      //   value: "BOOKED_DATE_IS_AFTER_COMMITTED",
      // },
    ],
  },
];

export const DATA_EXCEPTION_MESSAGE = {
  INCORRECT_CONTAINER_NUMBER_FORMAT: i18next.t("Container number is invalid"),
  INCORRECT_BILL_OF_LADING_FORMAT: i18next.t("Bill of Lading is invalid"),
  // PICK_UP_EVENT_MISSING: i18next.t("Pick-up event is missing"),
  ORIGIN_INVALID_COUNTRY_CODE: i18next.t("Origin country code is invalid"),
  ORIGIN_INVALID_REGION: i18next.t("Invalid Origin Region"),
  DESTINATION_INVALID_COUNTRY_CODE: i18next.t("Destination country code is invalid"),
  DESTINATION_INVALID_REGION: i18next.t("Invalid Destination Region"),
};

export const ORIGIN_EXCEPTIONS = ["ORIGIN_INVALID_COUNTRY_CODE", "ORIGIN_INVALID_REGION"];
export const DESTINATION_EXCEPTIONS = [
  "DESTINATION_INVALID_COUNTRY_CODE",
  "DESTINATION_INVALID_REGION",
];

export const DATA_EXCEPTION_TYPE = {
  INCORRECT_CONTAINER_NUMBER_FORMAT: "INCORRECT_CONTAINER_NUMBER_FORMAT",
  INCORRECT_BILL_OF_LADING_FORMAT: "INCORRECT_BILL_OF_LADING_FORMAT",
  // PICK_UP_EVENT_MISSING: "PICK_UP_EVENT_MISSING",
  ORIGIN_INVALID_COUNTRY_CODE: "ORIGIN_INVALID_COUNTRY_CODE",
  DESTINATION_INVALID_COUNTRY_CODE: "DESTINATION_INVALID_COUNTRY_CODE",
  ORIGIN_INVALID_REGION: "ORIGIN_INVALID_REGION",
  DESTINATION_INVALID_REGION: "DESTINATION_INVALID_REGION",
};

export const PAGE_NOT_FOUND_URL = "/page-not-found";

export const BACKGROUND_COLOR_EXCEPTIONS = ["#F87171", "#F87171", "#F87171", "#F87171"];

export const EXCEPTIONS_SUMMARY = {
  PICK_UP_UNSCHEDULED: {
    name: i18next.t("Pick-up unscheduled"),
    color: colors?.gray[300],
  },
  PICK_UP_LATE: {
    name: i18next.t("Pick-up late"),
    color: colors?.yellow[400],
  },
  POTENTIALLY_LATE: {
    name: i18next.t("Potentially late"),
    color: colors?.blue?.[400],
  },
  DELIVERED_LATE: {
    name: i18next.t("Delivered late"),
    color: colors.red?.[400],
  },
};

export const TOTAL_INVENTORY_STATUSES = {
  plannedToShip: {
    label: i18next.t("Planned to Ship"),
    color: colors.gray[300],
  },
  atOrigin: {
    label: i18next.t("At Origin"),
    color: colors.yellow[300],
  },
  inTransit: {
    label: i18next.t("In-Transit"),
    color: colors.blue[300],
  },
  atDestination: {
    label: i18next.t("At Destination"),
    color: colors.purple[300],
  },
  atWarehouse: {
    label: i18next.t("At Destination"),
    color: colors.green[300],
  },
  lostUnits: {
    label: i18next.t("Lost Units"),
    color: colors.red[300],
  },
};

export const PICKER_TYPES = {
  weekly: "weekly",
  monthly: "monthly",
  quarterly: "quarterly",
  yearly: "yearly",
};
export const IS_REFRESH_TOKEN_EVENT = "isRefreshToken";
export const IS_LOGOUT_EVENT = "isLogout";
export const IS_LOGGED_IN_EVENT = "isLoggedIn";
export const IS_EXPIRED_TOKEN = "isExpiredToken";
export const LOCATION_CHANGE = "locationChange";
export const SERVICE_NAME = "shipments";
export const ITEMS_PER_PAGE_PRODUCT = 4;

export const DEFAULT_VALUES = {
  notApplicable: "N/A",
  noData: "-",
};

export const DEFAULT_SORT_CONTAINER = {
  sortBy: "bookedTime",
  order: "desc",
};

export const DEFAULT_SORT_SHIPMENT = {
  ...DEFAULT_SORT_CONTAINER,
};

export const UNKNOWN_SECTION = {
  code: "*UNKNOWN*",
  name: "Unknown",
};

export const UNASSIGNED_SECTION = {
  code: UNKNOWN_SECTION.code,
  name: "Unassigned",
};

export const TRACKING_TYPE = {
  CONTAINERS_LABEL: i18next.t("freight"),
  CONTAINERS: "freight",
  SHIPMENTS_LABEL: i18next.t("shipments"),
  SHIPMENTS: "shipments",
};

export const CONTAINER_SOURCE = {
  CARRIER_DETAILS: "carrierDetails",
  PRODUCT_FAMILY_DETAILS: "productFamilyDetails",
  PRODUCT_CATEGORY_DETAILS: "productCategoryDetails",
  PRODUCT_DETAILS: "productDetails",
  AT_WAREHOUSE_REGION_DETAILS: "atWarehouseRegionDetails",
  AT_WAREHOUSE_COUNTRY_DETAILS: "atWarehouseCountryDetails",
  AT_WAREHOUSE_SITE_DETAILS: "atWarehouseSiteDetails",
  AT_ORIGIN_REGION_DETAILS: "atOriginRegionDetails",
  AT_ORIGIN_COUNTRY_DETAILS: "atOriginCountryDetails",
};

export const SHIPMENT_SOURCE = {
  ...CONTAINER_SOURCE,
};
export const SEPARATE_ARR_CHARACTER = "|";

export const SHIPMENT_API_URL = API_SERVICES?.SHIPMENT;
// Don't change constant below, you can extend it to use
export const PRODUCT_FILTER_PARAMS = ["from", "to", "carriers", "origins", "warehouses"];
export const CONTAINER_REQUEST_PARAMS = ["page", "pageSize", "source", "statuses", "sort"];

export const PICKER_MONTHS_TO_ADD = 3;
export const PICKER_WEEKS_TO_ADD = 13;
export const PICKER_QUARTERS_TO_ADD = 1;
export const SHIPMENT_EVENTS_ORDER = {
  XB: {
    index: 0,
  },
  AA: {
    index: 1,
  },
  AF: {
    index: 2,
  },
  C1: {
    index: 3,
  },
  P1: {
    index: 4,
  },
  VD: {
    index: 5,
  },
  B6: {
    index: 6,
  },
  X4: {
    index: 7,
  },
  VA: {
    index: 9,
  },
  X2: {
    index: 10,
  },
  IB: {
    index: 11,
  },
  CT: {
    index: 12,
  },
  PA: {
    index: 13,
  },
  SD: {
    index: 14,
  },
  PVA: {
    index: 15,
  },
  PVD: {
    index: 16,
  },
  PRL: {
    index: 17,
  },
  PRI: {
    index: 18,
  },
  PRE: {
    index: 19,
  },
  PRA: {
    index: 20,
  },
  PRU: {
    index: 21,
  },
  PAP: {
    index: 22,
    subIndex: 1,
  },
  PAT: {
    index: 22,
    subIndex: 2,
  },
  PDT: {
    index: 22,
    subIndex: 3,
  },
  PDP: {
    index: 22,
    subIndex: 4,
  },
  X6: {
    index: 26,
  },
  X5: {
    index: 27,
  },
  GR: {
    index: 28,
  },
};

export const ERROR_MESSAGES = (i18next: any) => {
  return {
    GENERAL_ERROR: i18next.t(
      "An error occurred while processing your request, we are actively addressing the issue.",
    ),
  };
};

export const DATA_EXCEPTION_TYPES = {
  INCORRECT_CONTAINER_NUMBER_FORMAT: "INCORRECT_CONTAINER_NUMBER_FORMAT",
  INCORRECT_BILL_OF_LADING_FORMAT: "INCORRECT_BILL_OF_LADING_FORMAT",
  PICK_UP_EVENT_MISSING: "PICK_UP_EVENT_MISSING",
  ORIGIN_INVALID_COUNTRY_CODE: "ORIGIN_INVALID_COUNTRY_CODE",
  DESTINATION_INVALID_COUNTRY_CODE: "DESTINATION_INVALID_COUNTRY_CODE",
  ORIGIN_INVALID_REGION: "ORIGIN_INVALID_REGION",
  DESTINATION_INVALID_REGION: "DESTINATION_INVALID_REGION",
  DELIVERED_EVENT_MISSING: "DELIVERED_EVENT_MISSING",
  MULTIPLE_PICK_UP_EVENTS: "MULTIPLE_PICK_UP_EVENTS",
  MULTIPLE_DELIVERY_EVENTS: "MULTIPLE_DELIVERY_EVENTS",
  DELIVERY_DATE_IS_AFTER_RECEIVED_DATE: "DELIVERY_DATE_IS_AFTER_RECEIVED_DATE",
  BOOKED_DATE_IS_AFTER_ESTIMATED_SHIPPED_DATE: "BOOKED_DATE_IS_AFTER_ESTIMATED_SHIPPED_DATE",
  BOOKED_DATE_IS_AFTER_INTRANSIT_DATE: "BOOKED_DATE_IS_AFTER_INTRANSIT_DATE",
  BOOKED_DATE_IS_AFTER_COMMITTED: "BOOKED_DATE_IS_AFTER_COMMITTED",
  AF_LOCATION_NOT_SAME_AS_ORIGIN: "AF_LOCATION_NOT_SAME_AS_ORIGIN",
  X5_LOCATION_NOT_SAME_AS_DESTINATION: "X5_LOCATION_NOT_SAME_AS_DESTINATION",
  SKU_MISSING: "SKU_MISSING",
  INCORRECT_MODE_OF_TRANSPORT: "INCORRECT_MODE_OF_TRANSPORT",
};

export const SHIPMENT_DATA_EXCEPTION_MESSAGES = (t: any) => ({
  [DATA_EXCEPTION_TYPES.INCORRECT_CONTAINER_NUMBER_FORMAT]: t("Container number is invalid"),
  [DATA_EXCEPTION_TYPES.INCORRECT_BILL_OF_LADING_FORMAT]: t("Bill of Lading is invalid"),
  [DATA_EXCEPTION_TYPES.PICK_UP_EVENT_MISSING]: t("Pick-up event is missing for container"), //
  [DATA_EXCEPTION_TYPES.ORIGIN_INVALID_COUNTRY_CODE]: t("Origin country code is invalid"),
  [DATA_EXCEPTION_TYPES.ORIGIN_INVALID_REGION]: t("Invalid Origin Region"),
  [DATA_EXCEPTION_TYPES.DESTINATION_INVALID_COUNTRY_CODE]: t("Destination country code is invalid"),
  [DATA_EXCEPTION_TYPES.DESTINATION_INVALID_REGION]: t("Destination region is invalid"),
  [DATA_EXCEPTION_TYPES.MULTIPLE_PICK_UP_EVENTS]: t(
    "There are multiple pick-up events for container",
  ), //
  [DATA_EXCEPTION_TYPES.MULTIPLE_DELIVERY_EVENTS]: t(
    "There are multiple delivered events for container",
  ), //
  [DATA_EXCEPTION_TYPES.DELIVERED_EVENT_MISSING]: t("Delivered event is missing for container"), //
  [DATA_EXCEPTION_TYPES.DELIVERY_DATE_IS_AFTER_RECEIVED_DATE]: t(
    "Received date is smaller than Delivered date for container",
  ), //
  [DATA_EXCEPTION_TYPES.SKU_MISSING]: t("SKU is missing for container"), //
  [DATA_EXCEPTION_TYPES.BOOKED_DATE_IS_AFTER_COMMITTED]: t(
    "Committed date is smaller than Booked date for container",
  ), //
  [DATA_EXCEPTION_TYPES.BOOKED_DATE_IS_AFTER_INTRANSIT_DATE]: t(
    "In-transit date is smaller than Booked date for container",
  ), //
  [DATA_EXCEPTION_TYPES.BOOKED_DATE_IS_AFTER_ESTIMATED_SHIPPED_DATE]: t(
    "Estimated shipped date is smaller than Booked date for container",
  ), //
  [DATA_EXCEPTION_TYPES.AF_LOCATION_NOT_SAME_AS_ORIGIN]: t(
    "Pick-up country does not match with origin country for container",
  ), //
  [DATA_EXCEPTION_TYPES.X5_LOCATION_NOT_SAME_AS_DESTINATION]: t(
    "Delivered country does not match with destination country for container",
  ), //
  [DATA_EXCEPTION_TYPES.INCORRECT_MODE_OF_TRANSPORT]: t("Mode of transport is incorrect"),
  [DATA_EXCEPTION_TYPES.AF_LOCATION_NOT_SAME_AS_ORIGIN]: t(
    "Pick-up country does not match with origin country for container",
  ),
});

export const DATA_EXCEPTION_MESSAGE_CONTAINER = (t: any) => ({
  [DATA_EXCEPTION_TYPES.INCORRECT_CONTAINER_NUMBER_FORMAT]: t("Container number is invalid"),
  [DATA_EXCEPTION_TYPES.PICK_UP_EVENT_MISSING]: t("Pick-up event is missing"),
  [DATA_EXCEPTION_TYPES.MULTIPLE_PICK_UP_EVENTS]: t("There are multiple pick-up events"),
  [DATA_EXCEPTION_TYPES.MULTIPLE_DELIVERY_EVENTS]: t("There are multiple delivered events"),
  [DATA_EXCEPTION_TYPES.DELIVERED_EVENT_MISSING]: t("Delivered event is missing"),
  [DATA_EXCEPTION_TYPES.DELIVERY_DATE_IS_AFTER_RECEIVED_DATE]: t(
    "Received date is smaller than Delivered date",
  ),
  [DATA_EXCEPTION_TYPES.SKU_MISSING]: t("SKU is missing"),
  [DATA_EXCEPTION_TYPES.BOOKED_DATE_IS_AFTER_COMMITTED]: t(
    "Committed date is smaller than Booked date",
  ),
  [DATA_EXCEPTION_TYPES.BOOKED_DATE_IS_AFTER_INTRANSIT_DATE]: t(
    "In-transit date is smaller than Booked date",
  ),
  [DATA_EXCEPTION_TYPES.BOOKED_DATE_IS_AFTER_ESTIMATED_SHIPPED_DATE]: t(
    "Estimated shipped date is smaller than Booked date",
  ),
  [DATA_EXCEPTION_TYPES.AF_LOCATION_NOT_SAME_AS_ORIGIN]: t(
    "Pick-up country does not match with origin country",
  ),
  [DATA_EXCEPTION_TYPES.X5_LOCATION_NOT_SAME_AS_DESTINATION]: t(
    "Delivered country does not match with destination country",
  ),
  [DATA_EXCEPTION_TYPES.INCORRECT_MODE_OF_TRANSPORT]: t("Mode of transport is incorrect"),
  [DATA_EXCEPTION_TYPES.AF_LOCATION_NOT_SAME_AS_ORIGIN]: t(
    "Pick-up country does not match with origin country",
  ),
});
